import React, { useState } from "react";
import Header from "./header";

import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import moment from "moment";
import NavBar from "./navBarContainer";

export default class Backend extends React.Component {
  // const loading = () => < div className = "animated fadeIn pt-3 text-center" > Loading... </div>;
  // console.log("props -->", props.propsInfo);
  // const [userDetails, setUserDetails] = useState(UserData);
  // const details = props.propsInfo;
  // console.log("props --> ", details);

  componentDidMount() {
    //initialize datatable
    $(document).ready(function() {
      $("#example").DataTable();
    });
  }

  render() {
    // DATABLEJS

    // console.log(this.props.propsInfo)
    const details = this.props.propsInfo;
    const address = details.walletAddress;
    return (
      <div className="sidemenu">
        <div className="wrapper">
          <NavBar />

          <div className="dash-app">
            <div id="content">
              <div className="toogle-button">
                <button type="button" id="sidebarCollapse" className="btn ">
                  <i className="fas fa-arrow-left" aria-hidden="true"></i>
                </button>
              </div>
              <Header />
              <div className="first-section">
                <div className="row justify-content-around">
                  <div className="value">
                    <div className="row">
                      <div className="col-4 pr-0 text-center align-self-center">
                        <img
                          src="../Asserts/address-icon.svg"
                          className="img-fluid"
                          alt=""
                        />
                      </div>
                      <div className="col-8">
                        <h6 className="boxHeader">Address</h6>
                        <h5 onclick="myFunction()">
                          {address
                            ? address.length > 6
                              ? address.slice(0, 3) +
                                "..." +
                                address.slice(
                                  address.length - 3,
                                  address.length
                                )
                              : address
                            : ""}
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div className="value">
                    <div className="row">
                      <div className="col-4 pr-0 text-center align-self-center">
                        <img
                          src="../Asserts/balance-icon.svg"
                          className="img-fluid"
                          alt=""
                        />
                      </div>
                      <div className="col-8">
                        <h6 className="boxHeader">Balance</h6>
                        <h5>{details.pawnsOfUser}</h5>
                      </div>
                    </div>
                  </div>
                  <div className="value">
                    <div className="row">
                      <div className="col-4 pr-0 text-center align-self-center">
                        <img
                          src="../Asserts/your-nodes.svg"
                          className="img-fluid"
                          alt=""
                        />
                      </div>
                      <div className="col-8">
                        <h6 className="boxHeader">Your nodes</h6>
                        <h5>{details.nodeNumbersOfUser}</h5>
                      </div>
                    </div>
                  </div>
                  <div className="value">
                    <div className="row">
                      <div className="col-4 pr-0 text-center align-self-center">
                        <img
                          src="../Asserts/total-nodes.svg"
                          className="img-fluid"
                          alt=""
                        />
                      </div>
                      <div className="col-8">
                        <h6 className="boxHeader">Total Nodes</h6>
                        <h5>{details.totalNodes}</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="modal fade"
                id="exampleModalCenter"
                tabindex="-1"
                role="dialog"
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-dialog-centered" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                    {/* <div class="modal-body text-center">
                      <h5> Are you sure to confirm your node </h5>
                      <br />
                      <button
                        type="button"
                        class="btn node-btn"
                        data-dismiss="modal"
                      >
                        Approve
                      </button>
                    </div> */}
                    {/* <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                      >
                        Close
                      </button>
                      <button type="button" class="btn btn-primary">
                        Save changes
                      </button>
                    </div> */}
                  </div>
                </div>
              </div>

              <div className="second-section ">
                <div className="row">
                  <div className="col-md-12">
                    <div className="own-node">
                      <h6>Create your own node</h6>
                      <h4>100 PAWN required to create a King</h4>
                      <input
                        type="text"
                        value={this.props.nodeNameToSet}
                        placeholder="Node name"
                        onChange={this.props.textInput}
                      />
                      <br />
                      <a
                        data-toggle="modal"
                        // data-target="#exampleModalCenter"
                        className="node-btn"
                        href=""
                        onClick={this.props.createNode}
                      >
                        Create node
                      </a>
                      <br />
                      <a
                        className="compound"
                        href=""
                        onClick={this.props.compound}
                      >
                        Compound
                      </a>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="table-values">
                      <table id="example" className="table table-borderless">
                        <thead>
                          <tr>
                            <th>Node Name</th>
                            <th>Creation time</th>
                            <th>Last Claim time</th>
                            <th> Total Rewards</th>
                            <th>
                              {" "}
                              <a
                                href=""
                                className="cashout "
                                onClick={this.props.cashoutAllNodes}
                              >
                                Cash Out all
                              </a>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.nodesCreateTime
                            .split("#")
                            .map((node, key) => {
                              // console.log("herehehrherhe ", node, key);
                              return (
                                <tr key={key}>
                                  <td className="pt-4">
                                    {this.props.nodeNames.split("#")[key]}
                                  </td>

                                  <td className="pt-4">
                                    {" "}
                                    {
                                      this.props.nodesCreateTime.split("#")[key]
                                      // &&
                                      // moment(new Date(this.props.nodesCreateTime.split("#")[key]*1000))?.format("DD:MM:YY") || ""
                                    }
                                  </td>
                                  <td className="pt-4">
                                    {
                                      this.props.nodesLastClaimTime.split("#")[
                                        key
                                      ]
                                      //    &&
                                      // moment(new Date(this.props.nodesLastClaimTime.split("#")[key]*1000))?.format("DD:MM:YY") || ""
                                    }
                                  </td>
                                  <td className="pt-4">
                                    {" "}
                                    {parseFloat(this.props.nodesRewards[key]) +
                                      parseFloat(
                                        this.props.RealTimeReards[key]
                                      )}
                                    {/* {parseFloat(this.props.nodesRewards[key])} */}
                                  </td>
                                  <td className="text-center">
                                    <button
                                      className="btn btn-cash-out"
                                      onClick={(event) => {
                                        event.preventDefault();
                                        // console.log(key)
                                        this.props.cashoutOneNode(
                                          this.props.nodesCreateTime.split("#")[
                                            key
                                          ]
                                        );
                                      }}
                                    >
                                      Cash Out
                                    </button>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center mt-3"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
